import React from 'react'
import DetailHotel from '../../ui/views/Hotel/DetailHotel/DetailHotel'

const HotelDetailRoute = () => {
  return (
    <DetailHotel/>
  )
}

export default HotelDetailRoute